import { createSlice } from '@reduxjs/toolkit';
import { REDUX_ASYNC_STATUSES } from '../../consts/consts';

const { IDLE, LOADING, SUCCEEDED, FAILED } = REDUX_ASYNC_STATUSES;

const initialState = {
  policiesToRisks: [],
  policiesToRisksStatus: IDLE,

  createPoliciesToRisksStatus: IDLE,
  deletePoliciesToRisksStatus: IDLE,

  bulkAddPoliciesToRisksStatus: IDLE,
  bulkRemovePoliciesFromRisksStatus: IDLE
};

const policiesToRisksSlice = createSlice({
  name: 'policiesToRisks',
  initialState,
  reducers: {
    createPoliciesToRisks: (state) => {
      state.createPoliciesToRisksStatus = LOADING;
    },
    createPoliciesToRisksSucceeded: (state) => {
      state.createPoliciesToRisksStatus = SUCCEEDED;
    },
    createPoliciesToRisksFailed: (state) => {
      state.createPoliciesToRisksStatus = FAILED;
    },

    getPoliciesToRisks: (state) => {
      state.policiesToRisksStatus = LOADING;
    },
    getPoliciesToRisksSucceeded: (state, action) => {
      state.policiesToRisks = action.payload;
      state.policiesToRisksStatus = SUCCEEDED;
    },
    getPoliciesToRisksFailed: (state) => {
      state.policiesToRisksStatus = FAILED;
    },

    deletePoliciesToRisks: (state) => {
      state.deletePoliciesToRisksStatus = LOADING;
    },
    deletePoliciesToRisksSucceeded: (state) => {
      state.deletePoliciesToRisksStatus = SUCCEEDED;
    },
    deletePoliciesToRisksFailed: (state) => {
      state.deletePoliciesToRisksStatus = FAILED;
    },

    bulkAddPoliciesToRisks: (state) => {
      state.bulkAddPoliciesToRisksStatus = LOADING;
    },
    bulkAddPoliciesToRisksSucceeded: (state) => {
      state.bulkAddPoliciesToRisksStatus = SUCCEEDED;
    },
    bulkAddPoliciesToRisksFailed: (state) => {
      state.bulkAddPoliciesToRisksStatus = FAILED;
    },

    bulkRemovePoliciesFromRisks: (state) => {
      state.bulkRemovePoliciesFromRisksStatus = LOADING;
    },
    bulkRemovePoliciesFromRisksSucceeded: (state) => {
      state.bulkRemovePoliciesFromRisksStatus = SUCCEEDED;
    },
    bulkRemovePoliciesFromRisksFailed: (state) => {
      state.bulkRemovePoliciesFromRisksStatus = FAILED;
    }
  }
});

export const {
  createPoliciesToRisks,
  createPoliciesToRisksSucceeded,
  createPoliciesToRisksFailed,
  getPoliciesToRisks,
  getPoliciesToRisksSucceeded,
  getPoliciesToRisksFailed,
  deletePoliciesToRisks,
  deletePoliciesToRisksSucceeded,
  deletePoliciesToRisksFailed,
  bulkAddPoliciesToRisks,
  bulkAddPoliciesToRisksSucceeded,
  bulkAddPoliciesToRisksFailed,
  bulkRemovePoliciesFromRisks,
  bulkRemovePoliciesFromRisksSucceeded,
  bulkRemovePoliciesFromRisksFailed
} = policiesToRisksSlice.actions;

export default policiesToRisksSlice.reducer;
